import { walletOffersApi } from "../features/offers/store";

export const walletOfferReducers = {
  [walletOffersApi.reducerPath]: walletOffersApi.reducer,
};

export const walletOfferMiddlewares = [walletOffersApi.middleware];

export { walletOffersApi };
